module.exports = __webpack_public_path__ + "static/media/office-costs.103ccb09.svg";